"use strict";
var constants = require('./constants/index');
var config = require("./config/index");
module.exports = {
    constants: constants,
    config: config
};
